import {createContext, useContext} from 'react';

export type SidebarInteractionSnackbarState = {
    message?: string;
    duration?: number | null;
};

const SidebarInteractionSnackbarContext = createContext<
    | [
          SidebarInteractionSnackbarState,
          React.Dispatch<React.SetStateAction<SidebarInteractionSnackbarState>>
      ]
    | undefined
>(undefined);

export function useSidebarInteractionSnackbarContext() {
    const context = useContext(SidebarInteractionSnackbarContext);
    if (context === undefined) {
        throw new Error(
            'useSidebarInteractionSnackbarContext must be used within SidebarInteractionSnackbarContextProvider'
        );
    }
    return context;
}

export default SidebarInteractionSnackbarContext;
